import { type InputHTMLAttributes, type TextareaHTMLAttributes, forwardRef } from "react";

import { cn } from "../../lib/cn";

const baseInput =
  "flex w-full rounded-md border border-border bg-bg-subtle px-3 py-2 text-sm text-fg placeholder:text-fg-faint disabled:cursor-not-allowed disabled:opacity-50 focus-visible:border-accent focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-accent transition-[border-color,box-shadow,background-color] duration-[var(--dur-med)] ease-[var(--ease-out)]";

export const Input = forwardRef<HTMLInputElement, InputHTMLAttributes<HTMLInputElement>>(
  ({ className, type = "text", ...props }, ref) => (
    <input ref={ref} type={type} className={cn(baseInput, "h-9", className)} {...props} />
  ),
);
Input.displayName = "Input";

export const Textarea = forwardRef<
  HTMLTextAreaElement,
  TextareaHTMLAttributes<HTMLTextAreaElement>
>(({ className, ...props }, ref) => (
  <textarea ref={ref} className={cn(baseInput, "min-h-[88px]", className)} {...props} />
));
Textarea.displayName = "Textarea";

export function Label({ className, ...props }: React.LabelHTMLAttributes<HTMLLabelElement>) {
  return (
    // biome-ignore lint/a11y/noLabelWithoutControl: htmlFor flows through ...props at call sites
    <label className={cn("block text-sm font-medium text-fg-muted", className)} {...props} />
  );
}
